import { useCallback, useEffect, useState } from "react";
import ToggleTabs from "../../ChartTableToggle";
import MonthVolumeAnalysis from "./MonthVolume";
import MonthCostAnalysis from "./MonthCost";
import { fetchMonthlyOptimalUtilisation } from "../../../../Utility/RestApi";
const DataTabs = ["Volume", "Cost"];

export default function MonthAnalysis({
  selectedBlock,
  refreshKey,
  setError,
  selectedTargetDate,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  selectedTargetDate: any[];
}) {
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);
  const handleFetchData = useCallback(async () => {
    // if (!preSelectedDate || !modSelectedSession) return;

    try {
      setLoading(true);
      const res = await fetchMonthlyOptimalUtilisation();
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);
  return (
    <>
      <div className="dash-card border border-[#718EBF1C] bg-white shadow-[rgba(149,157,165,0.2)_0px_8px_24px] w-full !min-h-[100%] rounded-2xl">
        <div className="flex justify-between items-center mb-1">
          <h2 className="chartHeading w-full">Monthly Optimal Utilisation</h2>
          <div className="flex items-center gap-3">
            <ToggleTabs
              tabs={DataTabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>
        </div>
        {activeTab === "Volume" && (
          <MonthVolumeAnalysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading}
            data={data}
            selectedTargetDate={selectedTargetDate}
          />
        )}
        {activeTab === "Cost" && (
          <MonthCostAnalysis
            selectedBlock={selectedBlock}
            refreshKey={refreshKey}
            setError={setError}
            loading={loading}
            data={data}
            selectedTargetDate={selectedTargetDate}
          />
        )}
      </div>
    </>
  );
}
